import { QuestionMark } from 'assets/icons';

function HelpLink({ text }) {
  return (
    <a
      href='https://help.raychat.io/'
      target='_blank'
      rel='noreferrer'
      className='flex flex-ai-c flex-colgap-8'
    >
      <img src={QuestionMark} alt='Question Mark' />

      <span className='font-bold main_section_header_moreInfo'>{text}</span>
    </a>
  );
}

export default HelpLink;
